import { AxiosInstance } from 'axios';

import { TripActionsRepositoryMock } from '@src/mocks/repositories/trip-actions.repository.mock';
import { CheckInOutRequest } from '@src/types/api/requests/check-in-out-request';

import { TripActionsRepository } from './trip-actions.repository';
import { TripActionsRepositoryAxios } from './trip-actions.repository.axios';

export class TripActionsService {
  constructor(private tripActionsRepository: TripActionsRepository) {}

  async changeTimes(tripId: string, checkInOutRequest: CheckInOutRequest): Promise<void> {
    await this.tripActionsRepository.changeTimes(tripId, checkInOutRequest);
  }

  async checkoutReservation(tripId: string) {
    return this.tripActionsRepository.checkoutReservation(tripId);
  }

  public static create(axiosInstance: AxiosInstance): TripActionsService {
    const isMockEnabled = process.env.NEXT_PUBLIC_MOCKS_ACTIVE === 'true';

    const tripActionsRepository = isMockEnabled
      ? new TripActionsRepositoryMock(axiosInstance)
      : new TripActionsRepositoryAxios(axiosInstance);

    return new TripActionsService(tripActionsRepository);
  }
}
